/* v25: header selection must not fail when iframe/browser storage is unavailable. */
(function () {
  'use strict';
  if (window.KMBrandContext) { window.KMBrandContext.refresh(); return; }
  var node = document.getElementById('km-brand-context-config'), config = {};
  try { config = JSON.parse(node ? node.textContent : '{}'); } catch (_) {}
  var memory = {};
  function read(key) {
    try { return localStorage.getItem(key) || memory[key] || ''; } catch (_) { return memory[key] || ''; }
  }
  function write(key, value) {
    memory[key] = value;
    try { localStorage.setItem(key, value); } catch (_) {} // Session-only fallback. Do not patch browser storage.
  }
  function safePath(value) {
    if (!value) return config.root || '/';
    try {
      var url = new URL(value, location.href), context = window.KMThemeContext || {};
      if (!/^https?:$/.test(url.protocol)) return config.root || '/';
      var hosts = [location.hostname];
      [context.shopUrl, context.permanentDomain].forEach(function (shop) {
        if (!shop) return;
        var host = new URL(shop.indexOf('://') === -1 ? 'https://' + shop : shop).hostname;
        hosts.push(host, host.replace(/^www\./, ''), 'www.' + host.replace(/^www\./, ''));
      });
      return hosts.indexOf(url.hostname) !== -1 ? url.pathname + url.search + url.hash : (config.root || '/');
    } catch (_) { return config.root || '/'; }
  }
  var brand = config.brand || read('active-brand-page');
  if (!/^[1-4]$/.test(brand)) brand = '1';
  var title = config.brand ? config.title || '' : read('active-page-title');
  var url = safePath(config.brand ? config.url : read('active-page-url'));
  window.active_brand_page = brand;
  window.active_page_title = title;
  window.active_page_url = url;
  var inEditor = window.KMThemeContext && window.KMThemeContext.isEditor();
  if (!inEditor) {
    write('active-brand-page', brand); write('active-page-title', title); write('active-page-url', url);
  }
  function refresh() {
    for (var i = 1; i <= 4; i++) {
      var header = document.getElementById('shopify-section-header' + i);
      if (header) {
        header.classList.toggle('active', String(i) === brand);
        var home = header.querySelector('.subheader__home');
        if (home && String(i) === brand) home.setAttribute('href', url);
      }
      document.querySelectorAll('.brand-block-' + i).forEach(function (block) { block.classList.toggle('active', String(i) === brand); });
    }
    document.querySelectorAll('.breadcrumb__item:first-child .breadcrumb__link').forEach(function (link) {
      link.setAttribute('href', url);
      if (title && !link.querySelector('.brand_page_title')) {
        var span = document.createElement('span'); span.className = 'brand_page_title'; span.textContent = title;
        link.appendChild(document.createTextNode(' (')); link.appendChild(span); link.appendChild(document.createTextNode(')'));
      }
    });
  }
  window.KMBrandContext = { refresh: refresh };
  refresh();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  document.addEventListener('shopify:section:load', refresh);
})();
